import React from 'react'
import { connect } from 'react-redux';
import OddFieldCircle from './OddFieldCircle'

class OddFields extends React.Component {

oddFieldsRenderer = () => {
    let {number, eventOddFields,clickable, zoom} = this.props;
    let oddFieldsElements = []
    eventOddFields &&  Object.values(eventOddFields).map((oddField) => {
        oddField && Object.values(oddField).map((item) => {
                if(item.betType.betTypeId <= 6 ){
                    item.locations &&  item.locations.map((location, i) => {
                        if(location.parent == number){
                          oddFieldsElements.push(<OddFieldCircle key={item.activeOddFieldId} clickable={clickable} oddFieldId={item.activeOddFieldId} position={location.position} oddField={item} zoom={zoom}/>)
                        }
                    })
                }
            })
        })
        return oddFieldsElements
}

render(){
    let {zoom} = this.props;

    return(
        <div style={{position: `${zoom ? "absolute" : ""}`}}>{this.oddFieldsRenderer()}</div>
    )
}

}

const mapStateToProps = (_, initialProps) => (state) => {
	return {
		loadingSportEvents: state.sportEvents.loadingSportEvents,
		eventsIds: state.sportEvents.eventsIds,
		error: state.sportEvents.error,
		connected: state.signalr.spinAndWinConnected,
		sportData: state.sportTypes.sportData,
		eventOdds: state.sportEvents.eventOdds,
		eventOddFields: state.sportEvents.eventOddFields,
		barItems: state.virtual.barItems,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
	
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(OddFields)